import { Card } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { Timer } from "@/src/components/deadlineTimer";

export const RechargeBalance = () => {
  const { nftBalance, charged, nextExpire, pendingRewards } = useBalances();
  return (
    <Card>
      <div className="space-y-1 mb-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">NFT Overview</h2>
      </div>
      <div className="space-y-0 divide-y divide-border/50">
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Charged Flare Reborn NFTs</span>
          <span className="text-base text-foreground font-mono whitespace-nowrap">
            {parseFloat(charged).toFixed(0)}/{parseFloat(nftBalance).toFixed(0)}
          </span>
        </div>
        {nextExpire > 0 &&
        <div className="flex items-center justify-between py-2.5 gap-3">
          <span className="text-sm text-muted-foreground">Next NFT Expiration</span>
          <span className="text-base text-primary font-mono whitespace-nowrap">
            {parseInt(nextExpire) > 0 ? <Timer time={parseInt(nextExpire)}/> : "00:00:00:00"}
          </span>
        </div>
        }
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Pending Rewards</span>
          <span className="text-base text-foreground font-mono whitespace-nowrap">
            {parseFloat(pendingRewards).toFixed(0)} <span className="text-primary">FRB</span>
          </span>
        </div>
      </div>
    </Card>
  );
};
